import React, { useContext, useState } from 'react';
import { Thumbnail } from '@remotion/player';


import { Player } from '@remotion/player';
import { MyComposition } from '../videos/RecruitingVideo';

const CustomVideoPlayer = () => {

  return (
    <>
    <div 
      style={{
        backgroundColor: 'transparent',
      }}
    
      >
      <div className="VideoContainer">
        <Player
          style={{ maxWidth: '900px', width: "100%" }}
          component={MyComposition}
          compositionWidth={1280}
          compositionHeight={720}
          durationInFrames={7600}
          fps={30}
          controls
        />
      </div>
      </div>
    </>
  );
};

export default CustomVideoPlayer;
